import type { WallBoard } from '@walls/store';
import { useWallParticipantsStore } from '@walls/store';
import { hasEnabledPageTool } from '../tools/PageTools';

export const useWorkspaceAccess = (board: WallBoard | null) => {
  const currentParticipantId = useWallParticipantsStore((state) => state.currentParticipantId);

  return getWorkspaceAccess(board, currentParticipantId);
};

export const getWorkspaceAccess = (board: WallBoard | null, currentParticipantId: string | null) => {
  const isParticipant = Boolean(currentParticipantId);
  const isOwner = Boolean(board?.isOwner);
  const canParticipate = Boolean(board && (board.isMember || board.canCollaborate));
  const canUseWorkspaceTools = Boolean(
    board && (isOwner || (isParticipant && (board.isMember || board.canCollaborate)))
  );
  const shouldShowJoinPanel = Boolean(canParticipate && !isOwner && !isParticipant);
  const canShowPageTools = Boolean(
    canUseWorkspaceTools &&
      board &&
      hasEnabledPageTool({
        allowCardCreation: board.allowCardCreation,
        allowClustering: board.allowClustering,
        allowDrawingTools: board.allowDrawingTools,
      })
  );

  return {
    canParticipate,
    canShowPageTools,
    canUseWorkspaceTools,
    isParticipant,
    shouldShowJoinPanel,
  };
};
